'use es6';

import aggregate from '../aggregate';
import getProperties from './properties';
export default function (config, _, runtimeOptions) {
  return getProperties(config).then(properties => aggregate(config, properties, runtimeOptions));
}